import React, { useState } from "react"
import { Link } from "react-router-dom"
import Head from "./Head"
import "./header.css"
// import Dropdown from 'react-bootstrap/Dropdown';
// import DropdownButton from 'react-bootstrap/DropdownButton';


const Header = () => {
  const [click, setClick] = useState(false)

  return (
    <>
      <Head />
      <header>
        <nav className='flexSB'>
          <ul className={click ? "mobile-nav" : "flexSB "} onClick={() => setClick(false)}>
            <li>
              <Link to='/'>Home</Link>
            </li>
            {/*<li>
              <Link to='/courses'>All Courses</Link>
  </li>*/}
            <li>
              <Link to=''>Degree Plan</Link>
            </li>
            <li>
              <Link to='/team'>Staff</Link>
            </li>
            <li>
              <Link to=''>Deadlines</Link>
            </li>
            <li>
              <Link to='/journal'>Essentials</Link>
            </li>
            <li>
              <Link to='/contact'>Contact</Link>
            </li>
          </ul>
          {/* <div className='start'>
            <div className='button'>GET CERTIFICATE</div>
          </div>
          <button className='toggle' onClick={() => setClick(!click)}>
            {click ? <i className='fa fa-times'> </i> : <i className='fa fa-bars'></i>}
          </button> */}
        </nav>
      </header>
    </>
  )
}

export default Header
